import React, { ReactNode, useEffect, useState } from 'react';

import AuthContext from './context/AuthContext';

import User from 'entities/User';
import useLoading from 'hooks/useLoading';

import AuthService from 'services/AuthService';

type Props = { children: ReactNode };

const authService = new AuthService();

const AuthContextProvider = ({ children }: Props) => {
	const [isFetched, setIsFetched] = useState<boolean>(false);
	const loading = useLoading();

	const [isAuth, setIsAuth] = useState<boolean>(false);
	const [user, setUser] = useState<User | null>(null);

	useEffect(() => {
		loading.enable();

		(async () => {
			loading.disable();

			await authService.me();
			updateInfo();
			setIsFetched(true);
		})();
	}, []);

	const updateInfo = () => {
		setUser(authService.getUser());
		setIsAuth(authService.getUser() !== null);
	};

	const login = async (name: string, password: string) => {
		await authService.login(name, password);

		updateInfo();
	};

	const logout = async () => {
		await authService.logout();

		updateInfo();
	};

	if (!isFetched) {
		return null;
	}

	const value = { isAuth, user, login, logout };

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
